import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useLangstonContentGet = <T>(contentId: string) => {
  const requestUrl = `${API_BASE_URL}/api/v3/content-document/${contentId}/`;
  return useRestQuery<T>(requestUrl, {
    skip: !contentId,
  });
};

export default useLangstonContentGet;
